export const MEDICAL_CANVASSING_STEP = "MEDICAL CANVASSING"
export const RECORDS_REQUEST_STEP = "RECORDS REQUEST"
export const SOCIAL_CANVASSING_STEP = "SOCIAL CANVASSING"
export const REQUESTOR_INFORMATION_STEP = "REQUESTOR INFORMATION"
export const CLAIMANT_INFORMATION_STEP = "CLAIMANT INFORMATION"
export const ORDER_REVIEW_STEP = "ORDER REVIEW"
